export const round = (value, precision) => {
    let multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
}




// WEBPACK FOOTER //
// ./src/components/helpers/round.js